import React, { Component } from 'react';

export default class KakaoTalkShareButton extends Component {
  componentDidMount() {
    const { label, image, webButton, profileId, postId } = this.props;
    Kakao.Link.createCustomButton({
      container: '.btn_talk',
      templateId: +`${process.env.REACT_APP_MESSAGE_TEMPLATE_ID}`, // s 681, p 19311
      templateArgs: {
        profileId,
        postId,
        title: label,
        imageUrl: image.src,
        imageWidth: image.width,
        imageHeight: image.height,
      }
    });
  }

  render() {
    return (
      <button type="button" className="btn_sns btn_talk">
        <span className="ico_plus" />카카오톡
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/KakaoTalkShareButton/index.js